<template>
    <div id="reagreeLegalTexts" v-if="newDocuments">
        <patternlib-headline :headline="$t('reagreeLegalTexts.headline')" heading-tag="h1" separator="none"/>
        <p style="margin-top: var(--spacing-5);">{{ $t("reagreeLegalTexts.explanation") }}</p>
        <legalTexts style="margin: var(--spacing-6) 0px;" ref="legalTexts"/>
        <patternlib-alert-message icon-name="info-circle" type="error" style="margin-bottom: var(--spacing-4);" v-if="alertMsg">
            {{ $t("reagreeLegalTexts.alert") }}
        </patternlib-alert-message>
        <patternlib-button 
            style="margin-right: var(--spacing-5)" 
            :label="$t('reagreeLegalTexts.agree')"
            @click="accept()"
        />
        <patternlib-button 
            :label="$t('reagreeLegalTexts.decline')"
            type="secondary"
            @click="this.$router.push('/logout')"
        />
    </div>

    <div id="spinner" v-if="!newDocuments">
        <patternlib-spinner spin/>
    </div>
</template>

<script>
import legalTexts from "../components/legalTexts/main.vue"
import { useServices } from "../services/useServices";
import { useAuth } from "../stores/authStore";
import { useGlobal } from "../stores/globalStore";

export default {
    data: () => ({
        newDocuments: false,
        alertMsg: false
    }),

    components: {
        legalTexts
    },

    methods: {
        accept() {
            const authStore = useAuth()
            if(this.$refs.legalTexts.accept()) {
                authStore.legalConformation = true
                this.$router.push("/")
                return
            }
            this.alertMsg = true
        }
    },

    created() {
        const services = useServices()
        const authStore = useAuth()
        const globalStore = useGlobal()
        services.$api.newDocumentsToAccept((available) => {
            if (!available) {
                authStore.legalConformation = true
                if(window.comebackRoute) {
                    this.$router.push(window.comebackRoute)
                }
                else {
                    this.$router.push("/")
                }
                return
            }
            this.newDocuments = true
        }, globalStore.language, globalStore.country)

        services.$api.applianceAvailable((available) => {
            globalStore.registeredApplianceAvailable = available
        })
        services.$api.getDwlConfigurationPage((data) => {globalStore.accessoryShopUrl = data}, globalStore.language, globalStore.country, "Accessory", window.location.origin);
        services.$api.getDwlConfigurationPage((data) => {globalStore.customerServiceUrl = data}, globalStore.language, globalStore.country, "CustomerService", window.location.origin);
        

        let preloadOnLogin = (import.meta.env.VITE_APP_PRELOAD_ON_LOGIN == "true")
        if (preloadOnLogin && !globalStore.preloadedData) {
            globalStore.preloadedData = true
            services.$api.getAllOrders((data) => {globalStore.orders = data})
            services.$api.getAppliances((data) => {globalStore.appliances = data})
            services.$api.getUserData((data) => {globalStore.userData = data})
        }
    }

}
</script>

<style lang="scss" scoped>
#reagreeLegalTexts {
    margin: 0px 96px;
}

#spinner {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

@media only screen and (max-width: 770px) { 
  #reagreeLegalTexts {
    margin: 0px 5vw;
  }

  patternlib-button {
    display: block !important;
    margin-bottom: var(--spacing-4);
    margin-right: 0px !important;
  }
}

</style>